module.exports = __webpack_public_path__ + "static/media/Icons_25 nov-09.dd26ab90.svg";